//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { result } from 'lodash-es';
import { mapGetters, mapMutations, mapActions } from "vuex";
import MyChart from "MyChart.vue";

export default {
  name: "OCCResult",
  props: {
    result: Object,
    openInNewWindow: Boolean,
    formatDate: Function,
  },
  data() {
		return {
      showMyChart: false,
      myChart: {
        apiKey: '',
        host: '',
        instance: '',
        visitType: '',
        department: '',
        provider: '',
        numDays: '',
        numSlotsPerDay: '',
        container: `open_scheduling_widget_${Math.floor(Math.random() * 1000)}`
      }
		};
	},
  computed: {
		// ...mapGetters(["myChart","showMyChart"])
	},
  methods: {
    // ...mapMutations(["setMyChart", "setShowMyChart"]),
    scheduleNow() {
      const myChartData = this.result.meta.myChart
      if(myChartData && myChartData !== null) {
        Object.assign(this.myChart, myChartData)
        this.showMyChart = true
        mychartWidget.renderWidget({ 
          "url":this.myChart.host,
          "apiKey":this.myChart.apiKey,
          "widgetType":"openschedulingsimple",
          "containerId":this.myChart.container,
          "additionalParams":{
            "visittype": this.myChart.visitType,
            "department": this.myChart.department,
            "provider": this.myChart.provider,
            "numdays": this.myChart.numDays,
            "numslotsperday": this.myChart.numSlotsPerDay

          }
        })
      }
      
      // if(myChartData && myChartData !== null){
      //   this.$emit("parseMyChart", myChartData)
      // }
    }
  }
};
